import React, { Component } from "react";
import CustomIcons from "../GlobalComponents/CustomIcons";


class InputChagePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.managePassword(false),
      showRequirements: false
    };
  }

  managePassword = show => {
    let type = show ? "text" : "password";
    return { type, show };
  };

  onClick = event => {
    event.preventDefault();
    let show = !this.state.show;
    this.setState(this.managePassword(show));
  };


  toggleRequirements = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showRequirements: !prevState.showRequirements }));
  }


  render() {
    let { type, showRequirements, show } = this.state;
    let { className, id, placeholder, required, onChange, value, minLength } = this.props;
    return (
      <>
        {this.props.title && ( <p style={{ fontWeight: 'bold', fontSize: '16px'}}>{ this.props.title  }</p> )}
        <div className="mb-2 input-group">
          <input
            type={type}
            className={className}
            id={id}
            placeholder={placeholder}
            required={required}
            onChange={onChange}
            value={value}
            style={{ padding: "0.9rem 0.75rem", borderRight: 'none'}}
            minLength={minLength}
          />
          <span 
            className="input-group-text" 
            onClick={this.onClick} 
            style={{ cursor: "pointer", borderLeft: 'none', background: "transparent"}}
          >

            <CustomIcons icon={show ? "eyeHide" : "eyeShow"}/>
          </span>
        </div>
        <div>
          {this.props.successMessage && this.props.successMessage != "" &&(<p style={{ color: "#009D07", fontSize: '14px', fontWeight:'400'}}> <CustomIcons icon="success"/>{" "}{" "}{this.props.successMessage}</p>)} 
          {this.props.errorMessage && this.props.errorMessage != "" &&(<p style={{ color: "#ED0008", fontSize: '14px', fontWeight:'400'}}> <CustomIcons icon="error"/>{" "}{" "}{this.props.errorMessage}</p>)}
          {this.props.requisitos && (
            <div className="mb-3">
              <a href="#" onClick={this.toggleRequirements} className="text-primary text-decoration-underline">Requisitos mínimos de seguridad</a>
              {showRequirements && (
                <div className="p-3 rounded mt-2" style={{ backgroundColor: '#D6EBFF' }}>
                  <ul className="mb-0">
                    <li>La contraseña debe contener al menos 8 caracteres.</li>
                    <li>Debe incluir al menos una letra mayúscula.</li>
                    <li>Debe incluir al menos una letra minúscula.</li>
                    <li>Debe contener al menos un número.</li>
                    <li>Debe incluir al menos un carácter especial (ejemplo: !@#$%^&*).</li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </>

    );
  }
}

export default InputChagePassword;
